import React from 'react'
import _ from 'lodash'
import { connect, ConnectedProps } from 'react-redux'
import { Oval } from 'react-loader-spinner'

import lang from 'lang'
import { changeModal } from 'services/actions'
import SchoolForm from 'common/components/school-form'
import { isUser } from 'common/utils'
import { AppState } from 'common/store/reducer'
import { User } from 'common/types'

interface OwnProps {
  submitSchool: (data: Record<string, { value: unknown; validations?: string }>) => void
}

const connector = connect(
  (state: AppState) => ({
    user: state.root.user,
    schoolFormData: state.manageSchool.form.formData as Record<string, unknown> & {
      id?: string
      started_ruler?: boolean
      salesforceId?: string
    },
    loading: state.manageSchool.request.loading,
  }),
  (dispatch) => ({
    changeModal: (params: Parameters<typeof changeModal>[0]) => dispatch(changeModal(params)),
  }),
)

type Props = ConnectedProps<typeof connector> & OwnProps

class SchoolFormModal extends React.Component<Props> {
  closeModal = (): void => {
    this.props.changeModal({ isOpen: false })
  }

  handleSaveClick = (): (() => void) => {
    return () => {
      const formData = this.props.schoolFormData
      const validations = (SchoolForm as unknown as { validations?: Record<string, string> })
        .validations
      let schoolData = _.mapValues(formData, (value, key) => ({
        value,
        validations:
          key === 'started_ruler_at' && !formData.started_ruler ? '' : validations?.[key],
      })) as Record<string, { value: unknown; validations?: string }>
      if (isUser.rulerAnyAdmin(this.props.user as User) && !schoolData.salesforceId) {
        schoolData = {
          ...schoolData,
          salesforceId: {
            value: formData.salesforceId || '',
            validations: validations?.salesforceId ?? '',
          },
        }
      }
      this.props.submitSchool(schoolData)
    }
  }

  render(): React.ReactNode {
    const formData = this.props.schoolFormData
    return (
      <div className="modal-wrapper">
        <div className="modal-header">
          <h2 id="add-new-school-header">
            {formData.id
              ? lang.dashboard.manageSchoolForm.updateTitle
              : lang.dashboard.manageSchoolForm.addTitle}
          </h2>
        </div>
        <div className="modal-container">
          <SchoolForm />
        </div>
        <div className="modal-footer">
          <div className="modal-button-wrapper">
            <button
              className="button save"
              disabled={this.props.loading}
              onClick={this.handleSaveClick()}
              type="button">
              {this.props.loading ? (
                <Oval
                  visible
                  width="20"
                  height="20"
                  color="#0f4d92"
                  secondaryColor="#33a650"
                  strokeWidth={6}
                />
              ) : (
                lang.saveButton
              )}
            </button>
            <button type="button" className="button clear cancel" onClick={() => this.closeModal()}>
              {lang.cancelButton}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default connector(SchoolFormModal)
